(function () {
  'use strict';

  var SOURCE_SELECTOR = '[id^="etranslate-language_currency-"][id*="-selector-theme"]';
  var MENU_SELECTOR = '[data-crosight-currency-menu]';
  var OPTION_SELECTOR = '[data-crosight-currency-option]';
  var SOURCE_CLASS = 'crosight-langwill-source';
  var sourceRoot = null;
  var sourceObserver = null;
  var documentObserver = null;
  var syncQueued = false;
  var switchingCurrency = false;

  function normalizeCode(value) {
    var match = String(value || '').toUpperCase().match(/[A-Z]{3}/);
    return match ? match[0] : '';
  }

  function currencyCountryCode(code) {
    var currencyCountries = {
      USD: 'US',
      CAD: 'CA',
      GBP: 'GB',
      EUR: 'EU',
      AUD: 'AU',
      NZD: 'NZ',
      JPY: 'JP',
      CNY: 'CN',
      HKD: 'HK',
      SGD: 'SG'
    };

    return currencyCountries[normalizeCode(code)] || 'US';
  }

  function currencyCountryName(code) {
    var currencyCountries = {
      USD: 'United States',
      CAD: 'Canada',
      GBP: 'United Kingdom',
      EUR: 'Europe',
      AUD: 'Australia',
      NZD: 'New Zealand',
      JPY: 'Japan',
      CNY: 'China',
      HKD: 'Hong Kong',
      SGD: 'Singapore'
    };

    return currencyCountries[normalizeCode(code)] || normalizeCode(code);
  }

  function createCurrencyFlag(code) {
    var flag = document.createElement('span');
    flag.className = 'country-flags country-flags--' + currencyCountryCode(code);
    flag.setAttribute('aria-hidden', 'true');
    return flag;
  }

  function normalizeSymbol(value) {
    return String(value || '').replace(/[()]/g, '').replace(/\s+/g, ' ').trim();
  }

  function formatLabel(code, symbol, rawLabel) {
    var normalizedSymbol = normalizeSymbol(symbol);

    if (!normalizedSymbol && rawLabel) {
      normalizedSymbol = normalizeSymbol(String(rawLabel).replace(new RegExp('^' + code, 'i'), ''));
    }

    return [code, normalizedSymbol].filter(Boolean).join(' ');
  }

  function readSourceItems(root) {
    var items = [];
    var seen = Object.create(null);

    if (!root) return items;

    root.querySelectorAll('.etranslate-currency-dropdown .etranslate-selector-dropdown-item').forEach(function (sourceOption) {
      var code = normalizeCode(sourceOption.getAttribute('data-code') || sourceOption.textContent);
      if (!code || seen[code]) return;

      var sourceLabel = sourceOption.querySelector('.etranslate-currency-name');
      var rawLabel = sourceLabel ? sourceLabel.textContent.trim() : sourceOption.textContent.trim();
      var symbol = sourceOption.getAttribute('data-symbol') || '';

      var label = formatLabel(code, symbol, rawLabel);

      seen[code] = true;
      items.push({
        code: code,
        label: label,
        optionLabel: currencyCountryName(code) + ' (' + label + ')'
      });
    });

    return items;
  }

  function readCurrentCode(root, items) {
    if (!root) return '';

    var appliedLabel = root.querySelector(
      '.selector-button > .etranslate-selector-list-button .etranslate-currency-name'
    );
    var selectedLabel = root.querySelector(
      '.etranslate-currency-selector-button .etranslate-currency-name'
    );
    var code = normalizeCode(appliedLabel ? appliedLabel.textContent : '');

    if (!code) code = normalizeCode(selectedLabel ? selectedLabel.textContent : '');
    if (!code && items && items.length) code = items[0].code;

    return code;
  }

  function hideSource(root) {
    if (!root) return;

    root.classList.add(SOURCE_CLASS);
    root.setAttribute('aria-hidden', 'true');

    root.querySelectorAll('button, a[href], input:not([type="hidden"]), select, textarea, [tabindex]').forEach(function (element) {
      element.setAttribute('tabindex', '-1');
    });
  }

  function observeSource(root) {
    if (sourceObserver) sourceObserver.disconnect();
    sourceObserver = null;

    if (!root) return;

    sourceObserver = new MutationObserver(scheduleSync);
    sourceObserver.observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'data-code', 'data-symbol']
    });
  }

  function connectSource() {
    var nextRoot = document.querySelector(SOURCE_SELECTOR);

    if (nextRoot !== sourceRoot) {
      sourceRoot = nextRoot;
      observeSource(sourceRoot);
    }

    hideSource(sourceRoot);
    return sourceRoot;
  }

  function createMenuOption(item, currentCode) {
    var option = document.createElement('button');
    option.type = 'button';
    option.className = 'popover-listbox__option';
    option.setAttribute('role', 'option');
    option.setAttribute('aria-selected', item.code === currentCode ? 'true' : 'false');
    option.setAttribute('data-crosight-currency-option', '');
    option.setAttribute('data-crosight-currency-code', item.code);
    option.appendChild(createCurrencyFlag(item.code));

    var label = document.createElement('span');
    label.textContent = item.optionLabel || item.label;
    option.appendChild(label);

    return option;
  }

  function renderMenu(menu, items, currentCode) {
    var label = menu.querySelector('[data-crosight-currency-label]');
    var flag = menu.querySelector('[data-crosight-currency-flag]');
    var listbox = menu.querySelector('[data-crosight-currency-options]');
    var currentItem = items.find(function (item) {
      return item.code === currentCode;
    }) || items[0];

    if (!currentItem || !listbox) return;

    if (label) label.textContent = currencyCountryName(currentItem.code);
    if (flag) flag.className = 'country-flags country-flags--' + currencyCountryCode(currentItem.code);

    var signature = currentCode + '|' + items.map(function (item) {
      return item.code + ':' + item.label + ':' + (item.optionLabel || '');
    }).join(',');

    if (listbox.getAttribute('data-crosight-currency-signature') !== signature) {
      var fragment = document.createDocumentFragment();

      items.forEach(function (item) {
        fragment.appendChild(createMenuOption(item, currentCode));
      });

      listbox.replaceChildren(fragment);
      listbox.setAttribute('data-crosight-currency-signature', signature);
    } else {
      listbox.querySelectorAll(OPTION_SELECTOR).forEach(function (option) {
        option.setAttribute(
          'aria-selected',
          option.getAttribute('data-crosight-currency-code') === currentCode ? 'true' : 'false'
        );
      });
    }

    listbox.setAttribute('aria-busy', 'false');
    menu.setAttribute('data-crosight-currency-ready', 'true');
  }

  function syncMenus() {
    syncQueued = false;

    var root = connectSource();
    var items = readSourceItems(root);
    if (!items.length) return;

    var currentCode = readCurrentCode(root, items);
    document.documentElement.dataset.crosightCurrencyCode = currentCode;
    document.querySelectorAll('[data-crosight-price-currency]').forEach(function (label) {
      label.textContent = currentCode;
    });
    document.querySelectorAll(MENU_SELECTOR).forEach(function (menu) {
      renderMenu(menu, items, currentCode);
    });
  }

  function scheduleSync() {
    if (syncQueued) return;
    syncQueued = true;
    window.requestAnimationFrame(syncMenus);
  }

  function closeMenu(menu) {
    if (!menu) return;

    var trigger = menu.querySelector('[aria-controls]');
    var popover = trigger ? document.getElementById(trigger.getAttribute('aria-controls')) : null;
    var isOpen = (popover && popover.open) || (trigger && trigger.getAttribute('aria-expanded') === 'true');

    if (isOpen && trigger) {
      window.requestAnimationFrame(function () {
        trigger.click();
      });
      return;
    }

    if (popover) popover.open = false;
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function setMenusBusy(isBusy) {
    document.querySelectorAll('[data-crosight-currency-options]').forEach(function (listbox) {
      listbox.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    });
  }

  function findSourceOption(root, code) {
    if (!root) return null;

    return Array.prototype.find.call(
      root.querySelectorAll('.etranslate-currency-dropdown .etranslate-selector-dropdown-item'),
      function (sourceOption) {
        return normalizeCode(sourceOption.getAttribute('data-code') || sourceOption.textContent) === code;
      }
    ) || null;
  }

  function chooseCurrency(code, menu) {
    var root = connectSource();
    var items = readSourceItems(root);
    var currentCode = readCurrentCode(root, items);
    var sourceOption = findSourceOption(root, code);

    closeMenu(menu);

    if (!root || !sourceOption || switchingCurrency) {
      scheduleSync();
      return;
    }

    if (code === currentCode) {
      scheduleSync();
      return;
    }

    switchingCurrency = true;
    setMenusBusy(true);

    sourceOption.click();

    window.setTimeout(function () {
      var applyButton = root.querySelector('.etranslate-change-button');

      if (applyButton) applyButton.click();

      switchingCurrency = false;
      setMenusBusy(false);
      scheduleSync();

      window.setTimeout(scheduleSync, 350);
      window.setTimeout(scheduleSync, 1200);
    }, 60);
  }

  function handleMenuClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var option = target.closest(OPTION_SELECTOR);
    if (!option) return;

    event.preventDefault();

    chooseCurrency(
      normalizeCode(option.getAttribute('data-crosight-currency-code')),
      option.closest(MENU_SELECTOR)
    );
  }

  function nodeContainsSource(node) {
    return node && node.nodeType === 1 && (
      node.matches(SOURCE_SELECTOR) ||
      (node.querySelector && node.querySelector(SOURCE_SELECTOR))
    );
  }

  function observeDocument() {
    if (documentObserver) documentObserver.disconnect();

    documentObserver = new MutationObserver(function (records) {
      var shouldReconnect = !sourceRoot || !document.documentElement.contains(sourceRoot);

      if (!shouldReconnect) {
        records.some(function (record) {
          return Array.prototype.some.call(record.addedNodes, nodeContainsSource) ||
            Array.prototype.some.call(record.removedNodes, nodeContainsSource);
        }) && (shouldReconnect = true);
      }

      if (shouldReconnect) {
        connectSource();
        scheduleSync();
      }
    });

    documentObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function injectSourceStyles() {
    if (document.getElementById('crosight-currency-source-styles')) return;

    var style = document.createElement('style');
    style.id = 'crosight-currency-source-styles';
    style.textContent = [
      SOURCE_SELECTOR + '.' + SOURCE_CLASS + ' {',
      '  position: fixed !important;',
      '  top: 0 !important;',
      '  right: auto !important;',
      '  bottom: auto !important;',
      '  left: -10000px !important;',
      '  width: 1px !important;',
      '  min-width: 1px !important;',
      '  max-width: 1px !important;',
      '  height: 1px !important;',
      '  min-height: 1px !important;',
      '  max-height: 1px !important;',
      '  margin: 0 !important;',
      '  padding: 0 !important;',
      '  overflow: hidden !important;',
      '  opacity: 0 !important;',
      '  clip: rect(0 0 0 0) !important;',
      '  clip-path: inset(50%) !important;',
      '  pointer-events: none !important;',
      '  transform: none !important;',
      '  z-index: -1 !important;',
      '}',
      SOURCE_SELECTOR + '.' + SOURCE_CLASS + ' .etranslate-language-list-popup-backdrop {',
      '  display: none !important;',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  function init() {
    injectSourceStyles();
    document.addEventListener('click', handleMenuClick, true);
    document.addEventListener('shopify:section:load', scheduleSync);
    document.addEventListener('shopify:section:reorder', scheduleSync);
    document.addEventListener('currency:refresh', scheduleSync);
    window.addEventListener('pageshow', scheduleSync);

    observeDocument();
    connectSource();
    scheduleSync();

    window.setTimeout(scheduleSync, 250);
    window.setTimeout(scheduleSync, 1000);
    window.setTimeout(scheduleSync, 2500);

    document.documentElement.dataset.crosightDisplayCurrencyMode = 'theme-menu';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.CroSightCurrencyDisplay = {
    apply: syncMenus,
    mode: 'theme-menu'
  };
})();
